import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Checkbox,
  IconButton,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import DeleteModal from "../DeleteModal/DeleteModal";
import "./DiaryCard.css";
import { fetchWithAuth } from "../../../utils/fetchWithAuth";

const API = process.env.REACT_APP_API_BASE;
const DiaryCard = ({
  id,
  title,
  description,
  checked,
  onSuccess,
  onToggle,
}) => {
  const [isChecked, setIsChecked] = useState(Boolean(checked));
  const [deleteOpen, setDeleteOpen] = useState(false);

  useEffect(() => {
    setIsChecked(Boolean(checked));
  }, [checked]);

  const handleToggle = async () => {
    try {
      const nextChecked = !isChecked;
      const response = await fetchWithAuth(`${API}/todos/${id}`, {
        method: "PUT",
        body: JSON.stringify({ checked: nextChecked }),
      });

      if (!response || !response.ok) {
        throw new Error("Failed to update todo status.");
      }

      setIsChecked(nextChecked);
      onToggle?.(id, nextChecked);
    } catch (error) {
      console.error("Failed to update checked state", error);
    }
  };

  const handleDelete = async () => {
    try {
      await fetchWithAuth(`${API}/todos/${id}`, {
        method: "DELETE",
        headers: {
        },
      });
      setDeleteOpen(false);
      onSuccess?.();
    } catch (error) {
      console.error("Failed to delete todo", error);
    }
  };

  return (
    <>
      <Card className="diary-card">
        <CardContent className="diary-card-content">
          <Box className="diary-card-header">
            <Checkbox
              checked={isChecked}
              onChange={handleToggle}
              icon={<CheckCircleOutlineIcon />}
              checkedIcon={<CheckCircleIcon />}
              className="diary-checkbox"
            />
          </Box>
          <Box className={`diary-text ${isChecked ? "done" : ""}`}>
            <Typography className="diary-title">{title}</Typography>
            <Typography className="diary-description">{description}</Typography>
          </Box>
          <IconButton
            onClick={() => setDeleteOpen(true)}
            className="diary-delete-button"
          >
            <CloseIcon />
          </IconButton>
        </CardContent>
      </Card>

      <DeleteModal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DiaryCard;
